export default "__VITE_ASSET__d69f07ee__"